import React, { Fragment } from "react";

export default function SpLast() {
  const data = [
    {
      heading: "Streamlined Booking",
      text: "Manage every unit effortlessly by filling out lead’s contact details, booking information, and track payment summary.",
    },
    {
      heading: "Detailed Unit Information",
      text: "Simply click on any unit to access all relevant details, including the unit number, size, and price",
    },
    {
      heading: "Streamlined Booking",
      text: "Manage every unit effortlessly by filling out lead’s contact details, booking information, and track payment summary.",
    },
    {
      heading: "Instant Document Generation",
      text: "Generate receipts instantly directly from the unit's dashboard.",
    },
  ];

  return (
    <Fragment>
      <div className="super-buildup-section">
        <div className="row my-5">
          <div className="col-md-6 col-12 d-flex align-items-center justify-content-center">
            <img
              src="/images/InteractiveProjectRightSide.png"
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="col-md-6 col-12">
            <h2 className="super-buildup-interactive-h2 mb-4">
              Interactive Project Unit Overview
            </h2>
            {data.map((val, idx) => (
              <div key={idx}>
                <h3 className="super-buildup-interactive-h4">{val.heading}</h3>
                <p className="super-buildup-interactive-h5">{val.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fragment>
  );
}
